export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/mayodeclaro2026.jpg',
	   "funcion": 'Llegó el momento de declarar.',
		"url" : 'https://www.facebook.com/reel/948864241251554',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/recuperacontra2026.jpg',
	   "funcion": 'Declaración de Modificación',
		"url" : 'https://www.facebook.com/SecretariaContraloriaHgo/posts/pfbid02HY5bs6sDrjypQ3C5BbqpnHzv52gyf1QTRX6jVTNpXcErAN5ayufym85sqauSMXmXl?rdid=W04ZDcVqt3wWOg3C#',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	   "funcion": 'Contraloría en Acción.',
		"url" : 'https://www.facebook.com/reel/2596979030765793git',
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]